import { HttpUtils } from '../common/http/HttpUtils';
import { PlanByTravelWLRequest } from './service-models/plan-by-travel-wl/PlanByTravelWLRequest';
import { PlanByTravelWLResult } from './service-models/plan-by-travel-wl/PlanByTravelWLResult';
import { BaseService } from '../service/BaseService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
import { CollateralDisplayRequest } from './service-models/collateral-display/CollateralDisplayRequest';
import { CollateralDisplayResult } from './service-models/collateral-display/CollateralDisplayResult';

/**
 * P建てサービス
 */
export class PlanByTravelWLService extends BaseService {
	// サービス メソッド  --------------------------------------------------------
	/**
	 * P建て
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public planByTravelWL(viewCore: WprBaseViewCore, request: PlanByTravelWLRequest, resMethod: (result: PlanByTravelWLResult) => void): void {
		return this.doPost(viewCore, '/plan/planByTravelWL', request, resMethod);
	}
	/**
	 * 選択されたプランの補償情報の取得
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public getCollateralDisplay(viewCore: WprBaseViewCore, request: CollateralDisplayRequest, resMethod: (result: CollateralDisplayResult) => void): void {
		return this.doPost(viewCore, '/plan/getCollateralDisplay', request, resMethod);
	}
	// --------------------------------------------------------------------------
}